import React from 'react';
// import PropTypes from 'prop-types';
import '../../assets/css/elements/input.css';

const FormInput = ({
    label,
    type = 'text',
    placeholder,
    value,
    onChange,
    name,
    error,
    icon,
    required = false,
    disabled = false,
    className = '',
    showLabel = false,
    children, // For select options
    helpText,
    showHelpText = false,
    rows = 4, // Default rows for textarea
    maxLength = 500, // Default max length for textarea
}) => {
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <div className={`form-input-container ${className}`}>
            {label && showLabel && (
                <label className="form-input-label">
                    {label}
                    {required && <span className="required-star">*</span>}
                </label>
            )}
            
            <div className="input-group">
                {icon && <span className="input-icon">{icon}</span>}
                {type === 'textarea' ? (
                    <>
                        <textarea
                            name={name}
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            disabled={disabled}
                            className={`form-input ${error ? 'error' : ''}`}
                            required={required}
                            maxLength={maxLength}
                            rows={rows}
                        />
                        <span className="character-count">
                            {value?.length || 0}/{maxLength}
                        </span>
                    </>
                ) : type === 'select' ? (
                    <select
                        name={name}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        className={`form-input ${error ? 'error' : ''}`}
                        required={required}
                    >
                        {placeholder && <option value="">{placeholder}</option>}
                        {children}
                    </select>
                ) : (
                    <input
                        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
                        name={name}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        disabled={disabled}
                        className={`form-input ${error ? 'error' : ''}`}
                        required={required}
                    />
                )}
                {type === 'password' && (
                    <span 
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? '👁️' : '👁️‍🗨️'}
                    </span>
                )}
                {type === 'select' && (
                    <span className="select-arrow">
                        ▼
                    </span>
                )}
            </div>
            
            {error && <span className="error-message">{error}</span>}
            {showHelpText && helpText && <small className="help-text">{helpText}</small>}
        </div>
    );
};

// FormInput.propTypes = {
//     label: PropTypes.string,
//     type: PropTypes.string,
//     placeholder: PropTypes.string,
//     value: PropTypes.string,
//     onChange: PropTypes.func.isRequired,
//     name: PropTypes.string,
//     error: PropTypes.string,
//     icon: PropTypes.element,
//     required: PropTypes.bool,
//     disabled: PropTypes.bool,
//     className: PropTypes.string,
// };

export default FormInput;